import { useEffect } from 'react'
import useSWR from 'swr'
import { useToken } from './auth/token'
import { fetcher } from './fetcher'
import { useCashStore } from './stateStore/cashStore'
import { useDepositNotiStore } from './stateStore/depositStore'
import { useSoundStore } from './stateStore/soundStore'
import { useTicketStore } from './stateStore/ticketStore'
import { useVaccount } from './stateStore/vaccountStore'
import { usePushNotification } from './usePushNotification'

export const useNotification = (
	url: any = '/admin/overview2',
	logout: boolean = false
) => {
	const { data: token } = useToken()
	const { data: newUser, mutate: mutateSound } = useSoundStore()
	const { data: newUser2, mutate: mutateSound2 } = useDepositNotiStore()
	const { data: newUser3, mutate: mutateSound3 } = useTicketStore()
	const { data: newUser4, mutate: mutateSound4 } = useCashStore()
	const { data: newUser5, mutate: mutateSound5 } = useVaccount()

	const { fireNotificationWithTimeout } = usePushNotification()

	useEffect(() => {
		const timer = setInterval(() => {
			mutateSound(0)
			mutateSound2(0)
			mutateSound3(0)
			mutateSound4(0)
			mutateSound5(0)
		}, 1000 * 10)

		return () => {
			clearInterval(timer)
		}
	}, [])

	const { data, mutate, error, isValidating } = useSWR(
		'/admin/overview2',
		async url => {
			if (!token && !logout) {
				return {}
			}
			const res = await fetcher('/admin/overview2', token, logout)
			const data = res?.result?.result

			if (data?.newwithdraw?.count > newUser2) {
				mutateSound2(data?.newwithdraw?.count)
				const config: any = {
					placement: 'topRight',
					duration: 100,
					message: '신규 출금 대기',
					description: '승인대기: ' + data?.newwithdraw?.count + '개',
				}

				fireNotificationWithTimeout(config.message, 5000, {
					body: config.description,
				})
				//notification.info(config)
			}
			if (data?.users?.joinUser > newUser) {
				mutateSound(data?.users?.joinUser)

				const config: any = {
					placement: 'topRight',
					duration: 100,
					message: '새로운 회원이 가입하였습니다.',
					description: '승인대기: ' + data?.users?.joinUser + '명',
				}
				fireNotificationWithTimeout(config.message, 5000, {
					body: config.description,
				})
				//notification.info(config)
			}
			if (data?.ticket?.waitingCount > newUser3) {
				mutateSound3(data?.ticket?.waitingCount)

				const config: any = {
					placement: 'topRight',
					duration: 100,
					message: '신규문의',
					description:
						'승인대기: ' + data?.ticket?.waitingCount + '개',
				}
				fireNotificationWithTimeout(config.message, 5000, {
					body: config.description,
				})
				//notification.info(config)
			}
			if (data?.cash?.new > newUser4) {
				mutateSound4(data?.cash?.new)

				const config: any = {
					placement: 'topRight',
					duration: 100,
					message: '신규 현금입출금',
					description: '승인대기: ' + data?.cash?.new + '개',
				}
				fireNotificationWithTimeout(config.message, 5000, {
					body: config.description,
				})
				//notification.info(config)
			}

			if (data?.vaccount?.count > newUser5) {
				mutateSound5(data?.vaccount?.count)

				const config: any = {
					placement: 'topRight',
					duration: 100,
					message: '신규 가상계좌신청',
					description: '발급대기: ' + data?.vaccount?.count + '개',
				}
				fireNotificationWithTimeout(config.message, 5000, {
					body: config.description,
				})
				//notification.info(config)
			}

			return data
		},
		{
			refreshInterval: 10000, // 10초마다 갱신 (실시간 알림 유지)
			revalidateOnMount: true, // 마운트 시 한 번 호출
			// 나머지는 전역 설정 사용
		}
	)
	return {
		data: data,
		playsound5: data?.vaccount?.count > newUser5,
		isLoading: isValidating,
		isError: error,
		refresh: mutate,
	}
}
